import { newrelic } from "@jti/fe-clients";
import type { Config } from "@jti/fe-common";
import { getConfig } from "@jti/fe-common";

import { createLegacyApiWarningAttributes, getIsEvo } from "../../utils";

import { LoyaltyApiEvo } from "./LoyaltyApiEvo";
import { LoyaltyApiLegacy } from "./LoyaltyApiLegacy";

export class LoyaltyApi {
  static init(config?: Config) {
    const resolvedConfig = config ?? getConfig();
    const isLoyaltyEnabled = resolvedConfig.IS_LOYALTY_ENABLED === "true";

    if (resolvedConfig.USE_EVO_ONLY) {
      return new LoyaltyApiEvo(
        resolvedConfig.EVO_DOMAIN,
        resolvedConfig.EVO_TENANT,
        resolvedConfig["X-RECAPTCHA-ID"],
        isLoyaltyEnabled
      );
    }
    if (getIsEvo(resolvedConfig.LOYALTY_URL)) {
      return new LoyaltyApiEvo(
        resolvedConfig.LOYALTY_URL,
        resolvedConfig.LOYALTY_TOKEN,
        resolvedConfig["X-RECAPTCHA-ID"],
        isLoyaltyEnabled
      );
    }
    newrelic.sendWarning(
      "LoyaltyApiLegacy initialized - legacy API client in use",
      createLegacyApiWarningAttributes(resolvedConfig, resolvedConfig.LOYALTY_URL, config !== undefined)
    );

    return new LoyaltyApiLegacy(resolvedConfig.LOYALTY_URL, resolvedConfig.LOYALTY_TOKEN);
  }
}
